import axios from 'axios';

const APIClient = axios.create({
    baseURL: process.env.REACT_APP_BASE_URL,
    xsrfCookieName: 'csrftoken',
    xsrfHeaderName: 'X-CSRFToken'
});

// Attach Bearer token if available — skipped automatically for login/register (no token yet)
APIClient.interceptors.request.use((config) => {
    const stored = localStorage.getItem('UserDetails');
    if (stored) {
        try {
            const { access_token } = JSON.parse(stored);
            if (access_token) {
                config.headers['Authorization'] = `Bearer ${access_token}`;
            }
        } catch (_) {
            // Malformed storage — proceed without token
        }
    }
    return config;
});

// Global 401 handler — clear session and redirect to login
APIClient.interceptors.response.use(
    (response) => response,
    (error) => {
        if (error?.response?.status === 401) {
            localStorage.removeItem('UserDetails');
            window.location.href = '/login';
        }
        return Promise.reject(error);
    }
);

export default APIClient;
